import $ from 'jquery'

export const init = async function (): Promise<void> {
  $('.js-resources-nav').on('change', function (evt) {
    const valueSelected: string | null =
      evt.delegateTarget instanceof HTMLSelectElement
        ? evt.delegateTarget.value
        : null

    if (valueSelected == null) {
      return
    }

    window.location.replace(valueSelected)
  })
}
